import { XMarkIcon } from '@heroicons/react/24/solid';
import { useDebounceEffect } from 'ahooks';
import { forwardRef, useImperativeHandle, useRef, useState } from 'react';

import { Input } from '@/components/ui/input.tsx';

const SearchBox = forwardRef<
  {
    setValue: (value: string) => void;
  },
  {
    onChange: (searchQuery: string) => void;
    /** Trang thai dang tai ket qua tu phia cha (pha fetch API). */
    loading?: boolean;
  }
>(({ onChange, loading = false }, ref) => {
  const searchInputRef = useRef<HTMLInputElement>(null);
  const [searchQuery, setSearchQuery] = useState('');
  // Dang cho debounce: nguoi dung vua go nhung chua goi onChange.
  const [isDebouncing, setIsDebouncing] = useState(false);

  useImperativeHandle(ref, () => ({
    setValue: (value: string) => {
      setSearchQuery(value);
      searchInputRef.current?.focus();
    },
  }));

  useDebounceEffect(
    () => {
      setIsDebouncing(false);
      onChange?.(searchQuery);
    },
    [searchQuery],
    {
      wait: 300,
    },
  );

  // Hien spinner khi dang cho debounce hoac dang fetch va co tu khoa.
  const showSpinner = (isDebouncing || loading) && searchQuery.length > 0;

  return (
    <>
      <Input
        ref={searchInputRef}
        type="text"
        placeholder="Search files..."
        value={searchQuery}
        onChange={(e) => {
          setSearchQuery(e.target.value);
          if (e.target.value) {
            setIsDebouncing(true);
          } else {
            setIsDebouncing(false);
          }
        }}
        className="pr-8"
        aria-busy={showSpinner}
      />
      {showSpinner ? (
        <div
          className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400"
          role="status"
          aria-label="Đang tìm kiếm"
        >
          <svg
            className="h-4 w-4 animate-spin"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
            />
          </svg>
        </div>
      ) : (
        searchQuery && (
          <button
            onClick={() => {
              setSearchQuery('');
              setIsDebouncing(false);
              searchInputRef.current?.focus();
            }}
            className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
            aria-label="Xóa tìm kiếm"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        )
      )}
    </>
  );
});

export default SearchBox;
